import { Typography, TypographyProps } from '@mui/material';

export const WisdomErrorMessage = (props: TypographyProps) => {
  return (
    <Typography variant="caption" color="error" {...props}>
      404 Brainwaves not found! 🧠 Our AI is off on a cosmic brainstorming
      journey. Try regenerating the response.
    </Typography>
  );
};
